import React from 'react'
import { SearchResultType, UserType } from '../../lib/types'
import Box from '@mui/material/Box'
import Card from '../Card'
import { useHistory } from 'react-router-dom'

const CollectionCard: React.FC<{ data: SearchResultType }> = ({ data }) => {
  const history = useHistory()

  return (
    <Box
      key={data.id}
      onClick={e => {
        if ((e.target as HTMLElement).id === 'shareButton') return
        history.push(`/a/collections/${data.id}?storyId=${data.items?.length ? data.items![0] : ''}`)
      }}
      sx={{
        cursor: 'pointer',
        marginBottom: 2
      }}
    >
      <Card
        loading={false}
        shareLink={data.publicAcl ? `${window.location.origin}/public/collections/${data.id}` : ''}
        type={'COLLECTION'}
        title={data.title}
        subTitle={`${data.storyCount ?? data?.items?.length ?? 0} stories`}
        owner={
          {
            firstName: data.ownerFirstName,
            lastName: data.ownerLastname,
            picture: {
              url: data.ownerPicture
            }
          } as UserType
        }
        thumbnail={data.picture!}
        numberOfPublishedStories={data.publishedStoriesCount ?? 0}
        id={data.id}
      />
    </Box>
  )
}

export default React.memo(CollectionCard)
